import toArray from 'lodash/toArray';
import makeVueControl from './makeVueControl';
import UnknownControl from '../controls/UnknownControl';

const DEFAULT_CONTROL = {
  control: makeVueControl(UnknownControl),
  invalid: true,
};

function getControlDescriptionForType(type, controlData, controlsMap) {
  if (controlsMap[type]) {
    return controlsMap[type];
  }
  // The key in the check controls dictionary does not necessarily
  // correspond to the type of the check because one check type
  // may be associated with multipe controls (e.g. Blood Pressure check
  // and temperature). In that scenario we look for an applicable control
  // by verifying matching types and the return value of the isApplicable function
  const isControlDescriptionApplicable = controlDescription => {
    const isApplicable = controlDescription.isApplicable || (() => true);
    if (controlData && !isApplicable(controlData)) {
      return false;
    }
    if (controlDescription.type === type) {
      return true;
    }
    if (controlDescription.types && controlDescription.types.includes(type)) {
      return true;
    }
    return false;
  };
  const applicableControlDescription = toArray(controlsMap).find(isControlDescriptionApplicable);
  return applicableControlDescription || DEFAULT_CONTROL;
}

function getControlForType(type, controlData, controlsMap) {
  return getControlDescriptionForType(type, controlData, controlsMap).control;
}

export { getControlDescriptionForType, getControlForType };
export default getControlForType;
